const messages = {
  title: "Prislister og brosjyrer PRODUKT",
  title_media: "Prislister og brosjyrer PRODUKT",
  description:
    "Last ned de nyeste brosjyrene og flygebladene om våre Bridgestone- og Firestone-dekk til personbiler, SUV-er og varebiler her.",
  short_description: "Her finner du data for sosiale medier, butikk-TV og mer.",
  mediaCategories: {
    products: "Produkter",
    brand_and_solutions: "Merke og løsninger",
    season_and_promotions: "Sesong og kampanjer",
    format: "Format",
    cars_and_vans: "Personbil, SUV, varebil",
    truck_and_buses: "Lastebiler og busser",
    motorcycle: "Motorsykkel",
    agriculture: "Landbruk",
    construction_machinery: "Anleggsmaskiner",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialer",
    brochures: "Produktbrosjyrer",
    price_list: "Prislister",
    materials: "Materialer",
    video_in_store: "Video med undertekster",
    video_online: "Video uten undertekster",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Sosiale medier",
    logos: "Logoer",
    summer: "Sommer",
    winter: "Vinter",
    all_season: "All sesong",
    promotions: "Kampanjer",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIABIBLIOTEK",
    description:
      "Velkommen til medieseksjonen dedikert   \n" +
      "til Bridgestone- og Firestone-produkter.  \n <br> <br>" +
      "Du vil oppdage produktbilder,   \n" +
      "logoer samt et bredt utvalg av   \n" +
      "bannere, videoer og digitalt materiell   \n" +
      "å bruke på nettstedet ditt eller på   \n" +
      "sosiale medier.  ",
    bDrive: {
      title: "Produktbilder",
      description:
        "Nåværende bilder   \n" +
        "kan lastes ned   \n" +
        "fra vårt B-\n" +
        "DRIVE-portal.  ",
    },
  },
  buttons: {
    media: "UTFORSK",
  },
  searchMedia: "Skriv inn søkeord",
  searchResults: "Søkeresultater",
};

export default {
  messages,
};
